export default __webpack_public_path__ + "static/media/hall_sense_breakout_lg.3a2c06ab.jpg";